// eslint-disable-next-line
import React, { ComponentType } from 'react';

import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { NOT_FOUND } from 'http-status-codes';
import { ReactQueryConfigProvider } from 'react-query';
import { SnackbarProvider } from 'components/Snackbar';
import esLocale from 'date-fns/locale/es';
import { withWfmTheme } from 'styles/wfmTheme';
import { MAX_RETRY_COUNT } from 'config';

export default function withAllProviders<P>(Component: ComponentType<P>) {
  function WithProviders(props: P) {
    const queryConfig = {
      queries: {
        retry: (failureCount, error) => {
          if (Number(error?.response?.data?.code) === NOT_FOUND) return false;
          return failureCount <= MAX_RETRY_COUNT;
        },
      },
    };

    return (
      <ReactQueryConfigProvider config={queryConfig}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
          <SnackbarProvider>
            <Component {...props} />
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </ReactQueryConfigProvider>
    );
  }

  return withWfmTheme(WithProviders);
}
